<form [formGroup]="loginForm" (ngSubmit)="checkForm() && !loading && sendLogin()">
  <div class="flex flex-col gap-2">
    <mat-form-field class="input-tg w-full" appearance="outline" hideRequiredMarker="true">
      <mat-label>E-mail</mat-label>
      <mat-icon matPrefix class="icone-campo" fontIcon="mail_outline"></mat-icon>
      <input id="email" type="email" matInput formControlName="email" autocomplete="email" placeholder="Ex: joao@email.com" />
    </mat-form-field>

    <mat-form-field class="input-tg w-full" appearance="outline" hideRequiredMarker="true">
      <mat-label>Senha</mat-label>
      <mat-icon matPrefix class="icone-campo" fontIcon="lock_outline"></mat-icon>
      <input
        id="password"
        [type]="hidePassword ? 'password' : 'text'"
        matInput
        formControlName="password"
        autocomplete="current-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hidePassword = !hidePassword"
        [attr.aria-label]="hidePassword ? 'Mostrar senha' : 'Ocultar senha'"
        [attr.aria-pressed]="!hidePassword"
      >
        <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="flex justify-end -mt-2">
    <a class="link-tg cursor-pointer text-sm" (click)="forgotPass()">Esqueceu sua senha?</a>
  </div>

  <button
    mat-flat-button
    type="submit"
    class="btn-tg w-full mt-6 h-12"
    [disabled]="!checkForm() || loading"
  >
    @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
    } @else {
      Entrar
    }
  </button>
</form>
